// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"55ceee6e","455":"4a13eb75","977":"e89b737b"}[chunkId] + ".chunk.js";
};